import React from "react";

export const PortfolioCard = ({
  src,
  title,
  shortDescription,
  technology = [],
  Section,
  Url,
  onClick
}) => {
  return (
    <div className="card portfolio-card-clickable" onClick={onClick}>
      <div className="imag">
        <img src={src} className="card-img-top" alt={title} />
      </div>

      <div className="card-body">
        <h5 className="card-title text-center">{title}</h5>
        <p className="text-center">{shortDescription}</p>

        <div className="techlist">
          {technology.map((tech, index) => (
            <div className="techli" key={index}>
              {tech}
            </div>
          ))}
          {Section === "REPORTS" && Url && (
            <a 
              href={Url} 
              target="_blank" 
              rel="noreferrer" 
              className="techli active-link" 
              onClick={(e) => e.stopPropagation()}
            >
              Open Report
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

